import { isPlatformBrowser, LocationStrategy } from "@angular/common";
import {
  Component,
  ComponentFactoryResolver,
  DestroyRef,
  ElementRef,
  inject,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  Renderer2,
  signal,
  viewChild,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { DomSanitizer, Meta, SafeHtml, Title } from "@angular/platform-browser";
import { ActivatedRoute, Router, UrlTree } from "@angular/router";

import { share } from "rxjs/operators";

import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
// import { MetaService } from '@ngx-meta/core';
import { CommonService } from "@services/common.service";
import { YTBSEOService } from "@services/ytb-seo.service";

import * as MetaContent from "../../../metacontent";
import { SharedService } from "../../../services/shared.service";
import {
  CAR_HOMEPAGE_CONTENT,
  FLIGHT_HOMEPAGE_CONTENT,
  HOMEPAGE_CONTENT,
} from "../../../templates/home-page-content";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@UntilDestroy()
@Component({
  selector: "app-home-page",
  templateUrl: "./home-page.component.html",
  styleUrls: ["./home-page.component.scss"],
})
export class HomePageComponent implements OnInit, OnDestroy {
  captionHtml = `<div class="container"><div class="caption-inner"><div class="row"><div class="col-12 col-lg-6 col-xl-7"><div class="hero-text"><h2 class="text-white">where you would like to go?</h2><p class="font800 font16 mt-20">Enjoy a grand trip around the world</p><div><div class="col-md-4"><a href="#" class="btn btn-primary btn-round btn-lg btn-wide mt-30">Book now</a></div></div></div></div></div></div></div>`;
  // @ViewChild("flightcontainer", { read: ViewContainerRef })
  // private flightcontainer = viewChild<ViewContainerRef>("flightcontainer");
  flightcontainer = viewChild("flightcontainer", {
    read: ViewContainerRef,
  });
  // @ViewChild("hotelcontainer", { read: ViewContainerRef })
  // private hotelcontainer: ViewContainerRef;
  // @ViewChild("carcontainer", { read: ViewContainerRef })
  // private carcontainer: ViewContainerRef;
  // @ViewChild("activitycontainer", { read: ViewContainerRef })
  // private activitycontainer: ViewContainerRef;
  // @ViewChild("flight") private flightel: ElementRef;
  // @ViewChild("hotel") private hotelel: ElementRef;
  // @ViewChild("car") private carel: ElementRef;
  // @ViewChild("activites") private activitiesel: ElementRef;
  geoCode = signal<any>(null);
  topDstns = signal<any[]>([]);
  destinationType = signal<any[]>([]);
  destinations = signal<any[]>([]);
  dstArr = signal<any[]>([]);
  bannerImages: Array<string> = [];
  deals = signal<any[]>([]);
  UserId = signal<string>("");
  params = signal<string>("");

  bannerLoader = signal(false);
  destinationsLoader = signal(false);
  dealsLoader = signal(false);
  public homeContent: SafeHtml;

  private readonly resolver = inject(ComponentFactoryResolver);
  private readonly router = inject(Router);
  private readonly sharedservice = inject(SharedService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly route = inject(ActivatedRoute);
  private readonly renderer = inject(Renderer2);
  private readonly title = inject(Title);
  private readonly meta = inject(Meta);
  private readonly metaService = inject(Meta);
  private readonly ytbseo = inject(YTBSEOService);
  private readonly common = inject(CommonService);
  private readonly sanitizer = inject(DomSanitizer);
  private readonly location = inject(LocationStrategy);

  private readonly platformId = inject(PLATFORM_ID);

  constructor() // private resolver: ComponentFactoryResolver,
  // private sharedservice: SharedService,
  // private renderer: Renderer2,
  // private router: Router,
  // private ytbseo: YTBSEOService,
  // private route: ActivatedRoute,
  // private title: Title,
  // private meta: Meta,
  // private metaService: Meta,
  // private common: CommonService,
  // private sanitizer: DomSanitizer,
  // @Inject(PLATFORM_ID) private platformId, private location: LocationStrategy
  {
    if (isPlatformBrowser(this.platformId) && typeof window !== "undefined") {
      history.pushState(null, null, window.location.href);
      this.location.onPopState(() => {
        history.pushState(null, null, window.location.href);
      });
    }
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId) && typeof window !== "undefined") {
      this.sharedservice.setTempRefId(new Date().getTime().toString());
    }
    this.bannerImages.push("assets/ytb-images/banner.jpg");

    this.sharedservice.GeoLocationParam$.pipe(
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((geoCode) => {
      if (geoCode != null && geoCode != "" && geoCode != undefined) {
        this.geoCode.set(geoCode);
        if (
          isPlatformBrowser(this.platformId) &&
          typeof window !== "undefined"
        ) {
          setTimeout(() => {}, 10000);
        }
      }
    });

    if (this.geoCode()) {
      this.getBannerImages();
      this.YTBTopDestinations();
      // this.getDeals();
    }

    this.sharedservice.ipAddressUrl$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((url) => {
        if (url != null && url != undefined && url != "") {
          this.fetchIPAddress(url);
        }
      });

    this.common.destinationSuccess
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((dest) => {
        if (dest != null && dest != undefined) {
          if (dest.result.length > 0) {
          }
        }
      });

    this.common.TopDestinations.pipe(
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((Dstns) => {
      if (Dstns) {
        if (Dstns.successCode) {
          this.topDstns.set(Dstns.result);

          this.getDestinationsByModule(
            this.params() ? this.getCodeByModule(this.params()) : "FT",
          );
        }
      }
    });

    this.common.ytbDynamicImages
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((response) => {
        if (response) {
          this.bannerLoader.set(false);
          this.deals.set([]);
          this.dealsLoader.set(false);
          this.destinationsLoader.set(false);

          if (response.successCode) {
            this.bannerImages.push(...response["result"]);
            this.deals.set(response["result"]);
            if (this.deals().length > 0) {
              this.deals.set(this.prepareTopDstns(this.deals()));
            }
          }
        }
      });

    this.common.deals$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((response) => {
        if (response != null && response != undefined) {
          this.deals.set([]);
          this.dealsLoader.set(false);
          this.destinationsLoader.set(false);

          if (response.successCode) {
            this.deals.set(response["result"]);
            if (this.deals().length > 0) {
              this.deals.set(this.prepareTopDstns(this.deals()));
            }
          }
        }
      });

    // this.sharedservice.loginUserId$
    //   .pipe(takeUntilDestroyed(this.destroyRef))
    //   .subscribe((userId) => {
    //     if (userId != null && userId != undefined) {
    //       this.UserId = userId;
    //     }
    //   });

    this.sharedservice.userDetailsParam
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((userDataObj) => {
        if (userDataObj != null && userDataObj != undefined) {
          if (userDataObj) {
            this.UserId.set(userDataObj.username);
          } else {
          }
        }
      });

    this.common.fetchIPAdressSuccess$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((response) => {
        if (response != null && response != undefined) {
          // this.sharedservice.setClientIpIn(response.ip);
        }
      });

    this.route.params.subscribe((param) => {
      if (param["tab"]) {
        // this.params = param['tab'];
        // this.getDestinationsByModule(this.getCodeByModule(this.params));
        // if (this.params === 'hotel') {
        //   this.ytbseo.createCanonicalURL(MetaContent.Canonical_URL.hotel);
        //   const hotels = MetaContent.Hotels[0].data;
        //   this.title.setTitle(hotels.title);
        //   this.meta.updateTag({ property: 'og:title', content: hotels.title });
        //   this.meta.updateTag({ name: 'twitter:title', content: hotels.title });
        //   this.meta.updateTag({ property: "og:url", content: hotels.url });
        //   this.meta.updateTag({ property: "og:description", content: hotels.description });
        //   this.meta.updateTag({ name: "twitter:description", content: hotels.description });
        //   setTimeout(() => {
        //     this.renderer.addClass(this.hotelel.nativeElement, "active");
        //     this.renderer.removeClass(this.flightel.nativeElement, "active");
        //     this.renderer.removeClass(this.carel.nativeElement, "active");
        //     this.renderer.removeClass(this.activitiesel.nativeElement, "active");
        //     this.showHotelSearchInputs();
        //   });
        // }
        // if (this.params === 'flight') {
        //   this.homeContent = this.sanitizer.bypassSecurityTrustHtml(FLIGHT_HOMEPAGE_CONTENT);
        //   const flights = MetaContent.Flights[0].data;
        //   this.metaService.setTitle(flights.title, true);
        //   this.metaService.setTag("twitter:title", flights.title);
        //   this.metaService.setTag("og:title", flights.title);
        //   this.metaService.setTag("description", flights.description);
        //   this.metaService.setTag("og:url", flights.url);
        //   this.ytbseo.createCanonicalURL(MetaContent.Canonical_URL.flight);
        //   setTimeout(() => {
        //     if (this.flightel && this.flightel.nativeElement)
        //       this.renderer.addClass(this.flightel.nativeElement, "active");
        //     if (this.carel && this.carel.nativeElement)
        //       this.renderer.removeClass(this.carel.nativeElement, "active");
        //     if (this.activitiesel && this.activitiesel.nativeElement)
        //       this.renderer.removeClass(this.activitiesel.nativeElement, "active");
        //     this.showFlightSearchInputs();
        //   }, 1000);
        // }
        // if (this.params === 'car') {
        //   this.homeContent = this.sanitizer.bypassSecurityTrustHtml(CAR_HOMEPAGE_CONTENT);
        //   const cars = MetaContent.Cars[0].data;
        //   this.metaService.setTitle(cars.title, true);
        //   this.metaService.setTag("twitter:title", cars.title);
        //   this.metaService.setTag("og:title", cars.title);
        //   this.metaService.setTag("description", cars.description);
        //   this.metaService.setTag("og:url", cars.url);
        //   this.ytbseo.createCanonicalURL(MetaContent.Canonical_URL.car);
        //   setTimeout(() => {
        //     if (this.carel && this.carel.nativeElement)
        //       this.renderer.addClass(this.carel.nativeElement, "active");
        //     if (this.flightel && this.flightel.nativeElement)
        //       this.renderer.removeClass(this.flightel.nativeElement, "active");
        //     if (this.activitiesel && this.activitiesel.nativeElement)
        //       this.renderer.removeClass(this.activitiesel.nativeElement, "active");
        //     this.showCarSearchInputs();
        //   });
        // }
        // if (this.params === 'activities') {
        //   const activities = MetaContent.Activities[0].data;
        //   console.log("== before setting title ==", activities.title);
        //   this.metaService.setTitle(activities.title, true);
        //   this.metaService.setTag("twitter:title", activities.title);
        //   this.metaService.setTag("og:title", activities.title);
        //   this.metaService.setTag("description", activities.description);
        //   this.metaService.setTag("og:url", activities.url);
        //   this.ytbseo.createCanonicalURL(MetaContent.Canonical_URL.activities);
        //   setTimeout(() => {
        //     if (this.activitiesel && this.activitiesel.nativeElement)
        //       this.renderer.addClass(this.activitiesel.nativeElement, "active");
        //     if (this.flightel && this.flightel.nativeElement)
        //       this.renderer.removeClass(this.flightel.nativeElement, "active");
        //     if (this.carel && this.carel.nativeElement)
        //       this.renderer.removeClass(this.carel.nativeElement, "active");
        //     this.showActivitySearchInputs();
        //   }, 1000);
        // }
      } else {
        this.showFlightSearchInputs();
      }
    });
  }

  changeFileTypeToWebP(imageUrl) {
    return imageUrl.replace(".png", ".webp");
  }

  changeFileTypeToJpg(imageUrl: string) {
    // if (imageUrl  ('.png'))
    return imageUrl.replace(".png", ".jpg");
  }

  getPopularDestinations(module) {
    this.destinations.set([]);
    if (module.length > 0) {
      this.common.getPopularDestinations([module]);
    }
  }

  ngAfterViewInit() {
    this.showFlightSearchInputs();
    this.homeContent = this.sanitizer.bypassSecurityTrustHtml(HOMEPAGE_CONTENT);
  }

  async showFlightSearchInputs() {
    // this.hotelcontainer.clear();
    // this.carcontainer.clear();
    // this.activitycontainer.clear();

    const { FlightSearchInputComponent } =
      await import("../../../ytb-modules/flight/flight-search-input/flight-search-input.component");

    const factory = this.resolver.resolveComponentFactory(
      FlightSearchInputComponent,
    );
    const container = this.flightcontainer();

    if (!container) {
      return;
    }

    if (container) {
      container.clear();
      container.createComponent(factory);
    }
  }

  navigateTabs(tab: string) {
    console.log(tab, "   TAb");
    switch (tab) {
      case "flight":
        this.router.navigate(["home", "flight"]);
        break;
      case "hotel":
        this.router.navigate(["home", "hotel"]);
        break;
      case "car":
        this.router.navigate(["home", "car"]);
        break;
      case "activities":
        this.router.navigate(["home", "activities"]);
        break;
      default:
        "";
    }
  }

  YTBTopDestinations() {
    this.common.YTBTopDestinations({
      modules: [],
    });
  }

  prepareTopDstns(topDstsArr: Array<any>) {
    let chunk = 3;
    let tempArr = [];
    for (let i = 0, j = topDstsArr.length; i < j; i += chunk) {
      tempArr.push(topDstsArr.slice(i, i + chunk));
    }
    return tempArr;
  }

  setClassName(value: number) {
    return value == 0 ? "active" : "";
  }

  navigateToLp(Obj: any, module: string) {
    let url: UrlTree;
    switch (module) {
      case "HL":
        url = this.router.createUrlTree(["lp/hotels/" + Obj.destination_Name]);
        break;
      case "FT":
        url = this.router.createUrlTree(["lp/flights/" + Obj.destination_Name]);
        break;
      case "CR":
        url = this.router.createUrlTree(["lp/cars/" + Obj.destination_Name]);
        break;
      case "SS":
        url = this.router.createUrlTree([
          "lp/activities/" + Obj.destination_Name,
        ]);
        break;
      default:
        this.router.createUrlTree(["/"]);
    }
    if (isPlatformBrowser(this.platformId) && typeof window !== "undefined") {
      window.open(url.toString(), "_blank");
    }
  }

  setGalleryClass(idx: number) {
    return idx == 0 ? "carousel-item active" : "carousel-item";
  }

  getDestinationsByModule(module: string) {
    this.destinations.set(
      this.topDstns().filter((x) => x["module_Type"] == module),
    );
    this.destinationType.set(
      this.destinations().map((x) => x["destination_Type"]),
    );
    this.destinationType.set(
      this.destinationType().filter(
        (x, i) => this.destinationType().indexOf(x) == i,
      ),
    );
    this.getDestinationsByType(
      this.destinationType().length ? this.destinationType()[0] : "",
    );
  }

  getDestinationsByType(dstType: string) {
    this.dstArr.set([]);

    let arr = this.destinations().filter(
      (x) => x["destination_Type"] == dstType,
    );
    this.dstArr.set(this.prepareTopDstns(arr));
    console.log(this.dstArr(), "dstArr");
  }

  setTabClass(indx: number) {
    return indx == 0 ? "t_nav-item t_nav-link active" : "t_nav-item t_nav-link";
  }

  getBannerImages() {
    this.common.YTBDynamicImages({
      foldername: "ytbdynamicresource,Home,locations",
      countryCode: this.geoCode()["countryCode"],
    });
  }

  getDeals() {
    // this.deals = [];
    // this.common.YTBDeals({
    //   foldername: 'ytbdynamicresource,Deals,locations',
    //   countryCode: this.geoCode['countryCode']
    // });
  }

  navigateToCoupons() {
    this.router.navigate(["/coupons"]);
  }

  getCodeByModule(module: string) {
    let mod = "";
    switch (module) {
      case "flight":
        mod = "FT";
        break;
      case "hotel":
        mod = "HL";
        break;
      case "car":
        mod = "CR";
        break;
      case "activities":
        mod = "SS";
        break;
    }
    return mod;
  }

  fetchIPAddress(url: string) {
    if (isPlatformBrowser(this.platformId) && typeof window !== "undefined") {
      if (
        localStorage.getItem("clientip") == null ||
        localStorage.getItem("clientip") == "" ||
        localStorage.getItem("clientip") == undefined
      ) {
        // this.common.fetchIPAddress(url);
      }
    }
  }

  ngOnDestroy() {
    this.common.dispose();
  }
}
